import request from "@/router/axios";

export const getList = (params) => {
  return request({
    url: "/api/produce/driver-entry-standard/page",
    method: "get",
    params,
  });
};

export const getDetail = (id) => {
  return request({
    url: "/api/produce/driver-entry-standard/detail",
    method: "get",
    params: { id },
  });
};

export const add = (row) => {
  return request({
    url: "/api/produce/driver-entry-standard/save",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/produce/driver-entry-standard/update",
    method: "post",
    data: row,
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/produce/driver-entry-standard/remove",
    method: "post",
    params: { ids },
  });
};

export const enable = (id) => {
  return request({
    url: "/api/produce/driver-entry-standard/enable",
    method: "post",
    params: { id },
  });
};

export const disable = (id) => {
  return request({
    url: "/api/produce/driver-entry-standard/disable",
    method: "post",
    params: { id },
  });
};

export const getSignList = (params) => {
  return request({
    url: "/api/produce/driver-entry-standard/sign-page",
    method: "get",
    params,
  });
};

export const getSignDetail = (id) => {
  return request({
    url: "/api/produce/driver-entry-standard/sign-detail",
    method: "get",
    params: { id },
  });
};
